import React, { useState, useRef } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { PopupMenu } from 'quantux-ui';
import WarningDialog from '../warning-dialog';
import { titleCase } from '../../utils';
import { salmon, blue } from '../../theme';

const PatientContactCard = (props) => {
  const [showMenu, setShowMenu] = useState(false);
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);

  const {
    contactPersonFirstName,
    contactPersonLastName,
    contactPersonRelationToPatient,
    contactPersonContactNumber,
    contactId,
    hasPowerOfAttorney
  } = props.data;

  let phoneUrl = '';
  if (contactPersonContactNumber && contactPersonContactNumber !== '') {
    const tmp = contactPersonContactNumber.replace(/-/g, '');
    phoneUrl = `tel:+1${tmp}`;
  }

  const menuRef = useRef();

  const styles = StyleSheet.create({
    ellipsisMenuContainer: {
      position: 'relative'
    },
    fieldValue: {
      color: 'white',
      paddingLeft: '8px'
    },
    ellipsisIcon: {
      color: blue[500],
      fontSize: '18px'
      // ':hover': {
      //   color: salmon[500]
      // }
    },
    popupMenuContainer: {
      background: '#083050',
      width: '120px',
      overflowY: 'auto',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)'
    },
    popupMenuItem: {
      height: '60px',
      background: blue[700],
      padding: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      cursor: 'pointer',
      ':hover': {
        color: blue[200],
        background: blue[900]
      }
    }
  });

  return (
    <>
      {showDeleteWarning &&
        <WarningDialog
          show={showDeleteWarning}
          title='Delete Contact Person'
          message='Do you want to delete contact person?'
          onCancel={() => setShowDeleteWarning(false)}
          onContinue={() => {
            setShowDeleteWarning(false);
            props.onDelete({ contactId });
          }}
        />
      }
      <div
        key={Math.random().toString(36).slice(2)}
        className='p-2 mt-2'
        style={{
          width: '359px',
          background: blue[700],
          borderRadius: '4px'
        }}
      >
        {/* Full Name */}
        <div
          className='fx'
          style={{
            justifyContent: 'space-between'
          }}
        >
          <div className='fx'>
            <div>Full Name: </div>
            <div className={css(styles.fieldValue)}>
              {!(contactPersonFirstName && contactPersonFirstName.length > 0) && !(contactPersonLastName && contactPersonLastName.length > 0)
                ? <span style={{ color: salmon[500] }}>Required</span>
                : <>
                  <span
                    style={{
                      color: contactPersonFirstName && contactPersonFirstName.length > 0 ? '' : salmon[500]
                    }}
                  >
                    {contactPersonFirstName && contactPersonFirstName.length > 0
                      ? `${titleCase(contactPersonFirstName)}`
                      : 'Required'
                    }
                  </span>&nbsp;
                  <span
                    style={{
                      color: contactPersonLastName && contactPersonLastName.length > 0 ? '' : salmon[500]
                    }}
                  >
                    {contactPersonLastName && contactPersonLastName.length > 0
                      ? `${titleCase(contactPersonLastName)}`
                      : 'Required'
                    }
                  </span>
                </>
              }
            </div>
          </div>
          <div
            className={css(styles.ellipsisMenuContainer)}
            ref={menuRef}
          >
            <i
              className={`fa fa-ellipsis-h ${css(styles.ellipsisIcon)}`}
              onClick={() => {
                setShowMenu(true);
              }}
            />
            {showMenu &&
              <PopupMenu
                top={24}
                right={1}
                visible={showMenu}
                parent={menuRef}
                position="absolute"
                onOutsideClick={() => { setShowMenu(false); }}
              >
                <div className={css(styles.popupMenuContainer)}>
                  {/* Edit */}
                  <div
                    className={css(styles.popupMenuItem)}
                    style={{
                      height: '32px',
                      padding: '8px'
                    }}
                    onClick={() => {
                      setShowMenu(false);
                      props.onEdit(props.data);
                    }}
                  >
                    <i className='fa fa-pencil mr-2' />
                    <div style={{ fontSize: '12px' }}>Edit</div>
                  </div>
                  {/* Delete */}
                  <div
                    className={css(styles.popupMenuItem)}
                    style={{
                      height: '32px',
                      padding: '8px'
                    }}
                    onClick={() => {
                      setShowMenu(false);
                      setShowDeleteWarning(true);
                    }}
                  >
                    <i className='fa fa-trash mr-2' />
                    <div style={{ fontSize: '12px' }}>Delete</div>
                  </div>
                </div>
              </PopupMenu>
            }
          </div>
        </div>
        {/* Relation To Patient */}
        <div className='fx'>
          <div>Relation To Patient: </div>
          <div
            className={css(styles.fieldValue)}
            style={{
              color: contactPersonRelationToPatient && contactPersonRelationToPatient.length > 0 ? '' : salmon[500]
            }}
          >
            {contactPersonRelationToPatient && contactPersonRelationToPatient.length > 0
              ? contactPersonRelationToPatient
              : 'Required'
            }
          </div>
        </div>
        {/* Contact Number */}
        <div className='fx'>
          <div>Contact Number: </div>
          <div
            className={css(styles.fieldValue)}
          >
            <a
              href={phoneUrl}
              style={{
                color: contactPersonContactNumber && contactPersonContactNumber.length > 0 ? '' : salmon[500]
              }}
            >
              {contactPersonContactNumber && contactPersonContactNumber.length > 0
                ? contactPersonContactNumber
                : 'Required'
              }
            </a>
          </div>
        </div>
        {/* Has power of Attorney */}
        <div className='fx'>
          <div>Has Power of Attorney: </div>
          <div className={css(styles.fieldValue)}>
            {hasPowerOfAttorney ? 'Yes' : 'No'}
          </div>
        </div>
      </div>
    </>
  );
};

export default PatientContactCard;
